import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/Authenticate/Refresh-Token', {
            withCredentials: true
        });
        // setAuth({ user: response.data.username, role: response.data.role, accessToken: response.data.accessToken, components: response?.data?.components });
        setAuth({
            user: response.data.username,
            fullName: response.data.fullName,
            email: response.data.email,
            role: response.data.role,
            accessToken: response.data.accessToken,
            userId: response.data.userId,
            components: response.data.components,
            universityId: response.data.universityId,
            universityName: response.data.universityName,
        });
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;
